import styled from 'styled-components';

export const Wrapper = styled.div<{ $isMe?: boolean }>`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  background-color: ${({ $isMe, theme }) => ($isMe ? theme.colors.purple1 : theme.colors.white)};
  padding: 12px 8px;
  border-radius: 4px;
`;

export const StartContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;

  @media (max-width: ${({ theme }) => theme.mediaQueries.sm}) {
    min-width: 60px;
  }
`;

export const EndContentWrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  color: ${({ theme }) => theme.colors.black7};

  @media (max-width: ${({ theme }) => theme.mediaQueries.sm}) {
    min-width: 120px;
  }
`;

export const BadgeWrapper = styled.span<{ $isRanking?: boolean }>`
  font-size: ${({ $isRanking }) => ($isRanking ? '30px' : '14px')};
  padding: ${({ $isRanking }) => ($isRanking ? '0' : '0 10px')};
  line-height: 0;

  font-style: normal;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black9};
`;

export const PointsWrapper = styled.div`
  display: flex;

  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  justify-content: end;
  color: ${({ theme }) => theme.colors.orange6};
  width: 85px;

  & > img {
    width: 24px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQueries.sm}) {
    width: 75px;
    font-size: 18px;

    & > img {
      width: 20px;
    }
  }
`;

export const NameWrapper = styled.div`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 70%;

  @media (max-width: ${({ theme }) => theme.mediaQueries.sm}) {
    max-width: 80px;
  }
`;
